export default {
    methods: {
        resetErrors() {
            for(const key in this.errors) {
                this.errors[key] = null;
            }
        },
        setErrors(apiErrors) {
            for(const key in apiErrors) {
                this.errors[key] = apiErrors[key][0];
            }

            console.log(this.errors)
        }
    }
}